<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import UserProfile from "@/router/views/users/user-profile"

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import UserUtils from '@/helpers/users';
import Storage from "@/helpers/storage";
import HelperUtils from "@/helpers/helper";

// Services
import LikesDataService from "@/services/LikesDataService";
import UsersDataService from "@/services/UsersDataService"

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import isEmpty from "is-empty";

export default {
  name: "likes",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Likes Analytics",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    CoolLightBox,
    UserProfile,
    VueTabs,
    VTab,
  },
  methods: {
    ...UserUtils,
    ...DateUtils,
    ...HelperUtils,

    handlePageChange(value) {
      this.page = value;
      this.loadLikes();
    },

    handleDisplayChange() {
      this.loadLikes();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.toDate = this.filters.fromDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    getMediaThumb() {
      if (!isEmpty(this.likes) && this.likes.length > 0) {
        this.likes.forEach(like => {
          if (like.likerPhoto && like.likerPhoto.length > 0)
            Storage.getUserMedia(like.actionUserId, like.likerPhoto, 'like-liker-' + like.documentId);

          if (like.userPhoto && like.userPhoto.length > 0)
            Storage.getUserMedia(like.userId, like.userPhoto, 'like-user-' + like.documentId);

          if (like.video.length > 0)
            Storage.getVideoLikeMedia(like.actionUserId, like.video, 'like-video-' + like.documentId);

        });
      }
    },

    getRequestParams() {
      let params = {};
      params["page"] = this.page - 1;
      params["size"] = this.pageSizes.selected;

      if (this.filters.genders.selected !== null)
        params['gender'] = this.filters.genders.selected;

      if (this.filters.types.selected !== null)
        params['resultType'] = this.filters.types.selected;

      if (this.filters.usersType.selected !== null)
        params['usersType'] = this.filters.usersType.selected;

      if (this.filters.subscribed.selected !== null)
        params['subscribed'] = this.filters.subscribed.selected;

      if (!isEmpty(this.filters.userId))
        params['userId'] = this.filters.userId;

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    resetData() {
      this.stats = {
        men: {
          likes: [],
          videoLikes: [],
          messagesFlash: [],
          matches: [],
          dislikes:[],
          likesCount: "-",
          messagesFlashCount: "-",
          videoLikesCount: "-",
          matchesCount: "-",
          dislikesCount: "-",
        },
        women: {
          likes: [],
          dislikes: [],
          videoLikes: [],
          messagesFlash: [],
          matches: [],
          likesCount: "-",
          messagesFlashCount: "-",
          videoLikesCount: "-",
          matchesCount: "-",
          dislikesCount: "-",
        },
      };
    },

    processFilters() {
      this.page = 1;
      this.resetData();
      this.loadLikes();
      this.loadStats();
    },

    loadLikes() {
      const params = this.getRequestParams();
      this.isLoading = true;
      LikesDataService.getList(params)
          .then(response => {
            const { items, totalItems } = response.data;
            if (!isEmpty(items))
              this.likes = items;

            this.count = totalItems;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error("LikesDataService.getList failed...", error);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    loadStats() {
      const params = this.getRequestParams();

      LikesDataService.getStats(params)
          .then(response => {
            this.stats = response.data;
            this.$refs.matchesChartRef.updateSeries([{
              name: "Men Matches",
              data: response.data.men.matches
            },{
              name: "Women Matches",
              data: response.data.women.matches
            }]);

            this.$refs.likesChartRef.updateSeries([{
              name: "Men Likes",
              data: response.data.men.likes
            },{
              name: "Women Likes",
              data: response.data.women.likes
            }]);

            this.$refs.videoLikesChartRef.updateSeries([{
              name: "Men VideoLikes",
              data: response.data.men.videoLikes
            },{
              name: "Women VideoLikes",
              data: response.data.women.videoLikes
            }]);

            this.$refs.messagesFlashChartRef.updateSeries([{
              name: "Men Flash Messages",
              data: response.data.men.messagesFlash
            },{
              name: "Women Flash Messages",
              data: response.data.women.messagesFlash
            }]);

            this.$refs.dislikesChartRef.updateSeries([{
              name: "Men Dislikes",
              data: response.data.men.dislikes
            },{
              name: "Women Dislikes",
              data: response.data.women.dislikes
            }]);

          })
          .catch(error => {
            window.console.error("StatsDataService.getLikesStats failed...", error);
          });
    },

    showMedia(like) {
      let mediaId = like.video.replace(".jpg", ".mp4");
      mediaId = mediaId.replace("th_", "");

      Storage.getVideoLikeMediaUrl(like.actionUserId, mediaId)
          .then((url) => {
            const media = {
              "id": 1,
              "userId": like.actionUserId,
              "mediaId": mediaId,
              "createdAt": "",
              "typeMedia": 1,
              "src": url,
              "title": "1/1",
            };

            this.showUserMedia([media], 0);
          });
    },

    showUserMedia(media, index) {
      this.media.media = media;
      this.media.index = index;
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      if (isEmpty(userId))
        return;

      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },
  mounted() {
    this.processFilters();
  },
  computed: {
    ...authComputed
  },
  data() {
    return {
      isLoading: false,
      title: this.$t("menuitems.dashboards.app"),
      stats: {
        men: {
          likes: [],
          videoLikes: [],
          messagesFlash: [],
          matches: [],
          dislikes: [],
          likesCount: "-",
          dislikesCount: "-",
          messagesFlashCount: "-",
          videoLikesCount: "-",
          matchesCount: "-",
        },
        women: {
          likes: [],
          dislikes: [],
          videoLikes: [],
          messagesFlash: [],
          matches: [],
          likesCount: "-",
          dislikesCount: "-",
          messagesFlashCount: "-",
          videoLikesCount: "-",
          matchesCount: "-",
        },
      },
      seriesDislikes:[],
      seriesMatches:[],
      seriesLikes:[],
      seriesVideoLikes:[],
      seriesMessagesFlash:[],
      chartOptionsDislikes: {
        chart: {
          id: 'dislikesChartEvo',
          type: 'bar',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        }
      },
      chartOptionsMatches: {
        chart: {
          id: 'matchesChartEvo',
          type: 'bar',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        }
      },
      chartOptionsMessagesFlash: {
        chart: {
          id: 'messagesFlashChartEvo',
          type: 'bar',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        }
      },
      chartOptionsLikes: {
        chart: {
          id: 'likesChartEvo',
          type: 'bar',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        }
      },
      chartOptionsVideoLikes: {
        chart: {
          id: 'videoLikesChartEvo',
          type: 'bar',
          height: 350,
          zoom: {
            autoScaleYaxis: true
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true
            }
          }
        },
        colors: ['#77B6EA', '#f06292'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          labels: {
            show: true,
            style: {
              fontSize: 0
            },
            hideOverlappingLabels: true
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1
        },
        noData: {
          text: 'Loading...'
        }
      },
      count: 0,
      likes: [],
      page: 1,
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '50'
      },

      filters: {
        userId: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'last30Day',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        subscribed: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.subscribed_all")},
            {value: 1, text: this.$t("users.subscribed")},
            {value: 0, text: this.$t("users.no_subscribed")},
          ]
        },
        usersType: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_userTypes")},
            {value: 'natural', text: this.$t("users.only_natural")},
            {value: 'natural-noNatural', text: this.$t("users.natural_to_noNatural")},
            {value: 'others', text: "Others"},
          ]
        },
        types: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("likes.result_all")},
            {value: 'likes', text: this.$t("likes.result_likes")},
            {value: 'matches', text: this.$t("likes.result_matches")},
            {value: 'videoLikes', text: this.$t("likes.result_videoLikes")},
            {value: 'messagesFlash', text: this.$t("likes.result_messagesFlash")},
            {value: 'dislikes', text: this.$t("likes.result_dislikes")},
          ]
        }
      },

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      media: {
        media: [],
        index: -1
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Filters -->
      <div class="card">
        <div class="card-body">
          <!-- filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" id="likesFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="likesDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="likesGenderFilter"
                  v-model="filters.genders.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Types -->
            <div class="col-sm-auto">
              <b-form-select
                  id="likesTypesFilter"
                  v-model="filters.types.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.types.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Users Types -->
            <div class="col-sm-auto">
              <b-form-select
                  id="likesUsersTypesFilter"
                  v-model="filters.usersType.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.usersType.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Subscribed -->
            <div class="col-sm-auto">
              <b-form-select
                  id="likesSubFilter"
                  v-model="filters.subscribed.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.subscribed.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- UserId -->
            <div class="col-sm-auto">
              <b-form-input
                  id="likesUserId"
                  class="me-lg-1"
                  v-model="filters.userId"
                  placeholder="UserId…">
              </b-form-input>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Graphs 1 -->
      <div class="row mb-3">

        <!-- Matches -->
        <div class="col-12 col-lg-6">

          <!-- data -->
          <div class="row">

            <!-- Men -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Matches Men</p>
                      <h4 class="mb-0">{{ stats.men.matchesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-info">
                      <i class="bx bxs-flame font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Women -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Matches Women</p>
                      <h4 class="mb-0">{{ stats.women.matchesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-pink">
                      <i class="bx bxs-flame font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- graph -->
          <div class="card">
            <div class="card-body" id="matchesChartEvo">
              <h5 class="card-title">Matches</h5>
              <apexchart
                  ref="matchesChartRef"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="seriesMatches"
                  :options="chartOptionsMatches"
              ></apexchart>
            </div>
          </div>

        </div>

        <!-- VideoLikes -->
        <div class="col-12 col-lg-6">

          <!-- data -->
          <div class="row">

            <!-- Men -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">VideoLikes Men</p>
                      <h4 class="mb-0">{{ stats.men.videoLikesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-info">
                        <i class="bx bxs-video-recording font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Women -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">VideoLikes Women</p>
                      <h4 class="mb-0">{{ stats.women.videoLikesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-pink">
                        <i class="bx bxs-video-recording font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- graph -->
          <div class="card">
            <div class="card-body" id="videoLikesChartEvo">
              <h5 class="card-title">VideoLikes</h5>
              <apexchart
                  ref="videoLikesChartRef"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="seriesVideoLikes"
                  :options="chartOptionsVideoLikes"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Graphs 2 -->
      <div class="row mb-3">

        <!-- Likes -->
        <div class="col-12 col-lg-6">

          <!-- data -->
          <div class="row">

            <!-- Men -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Likes Men</p>
                      <h4 class="mb-0">{{ stats.men.likesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-info">
                      <i class="bx bxs-heart font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Women -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Likes Women</p>
                      <h4 class="mb-0">{{ stats.women.likesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-pink">
                      <i class="bx bxs-heart font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- graph -->
          <div class="card">
            <div class="card-body" id="likesChartEvo">
              <h5 class="card-title">Likes</h5>
              <apexchart
                  ref="likesChartRef"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="seriesLikes"
                  :options="chartOptionsLikes"
              ></apexchart>
            </div>
          </div>

        </div>

        <!-- MessagesFlash -->
        <div class="col-12 col-lg-6">

          <!-- data -->
          <div class="row">

            <!-- Men -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Messages Flash Men</p>
                      <h4 class="mb-0">{{ stats.men.messagesFlashCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-info">
                      <i class="bx bxs-heart font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Women -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Messages Flash  Women</p>
                      <h4 class="mb-0">{{ stats.women.messagesFlashCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-pink">
                      <i class="bx bxs-heart font-size-24"></i>
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- graph -->
          <div class="card">
            <div class="card-body" id="messagesFlashChartEvo">
              <h5 class="card-title">Messages Flash</h5>
              <apexchart
                  ref="messagesFlashChartRef"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="seriesMessagesFlash"
                  :options="chartOptionsMessagesFlash"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Graphs 3 -->
      <div class="row mb-3">

        <!-- Dislikes -->
        <div class="col-12 col-lg-6">

          <!-- data -->
          <div class="row">

            <!-- Men -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Dislikes Men</p>
                      <h4 class="mb-0">{{ stats.men.dislikesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-info">
                        <i class="bx bxs-no-entry font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Women -->
            <div class="col-12 col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="media">
                    <div class="media-body">
                      <p class="text-dark fw-medium mb-2">Dislikes Women</p>
                      <h4 class="mb-0">{{ stats.women.dislikesCount | formatNumber}}</h4>
                    </div>

                    <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                      <span class="avatar-title bg-pink">
                        <i class="bx bxs-no-entry font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- graph -->
          <div class="card">
            <div class="card-body" id="dislikesChartEvo">
              <h5 class="card-title">Dislikes</h5>
              <apexchart
                  ref="dislikesChartRef"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="seriesDislikes"
                  :options="chartOptionsDislikes"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>

          {{ count | formatNumber}} {{ $t('resultsCount') }}
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="likes-list"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- Result list -->
      <div class="row card" v-if="!isLoading && likes.length > 0">
        <div class="table-responsive card-body">
          <table
              id="likes-list"
              class="table project-list-table table-nowrap table-centered table-borderless align-middle"
          >
            <thead>
            <tr>
              <th scope="col">{{ $t('likes.likedAt') }}</th>
              <th scope="col">{{ $t('likes.result') }}</th>
              <th scope="col">{{ $t('likes.likerId') }}</th>
              <th scope="col">{{ $t('likes.userId') }}</th>
              <th scope="col">Diff.</th>
              <th scope="col">Data</th>
              <th scope="col">{{ $t('likes.disabled') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="like in likes" :key="like.documentId">
              <td>
                <p class="text-muted font-size-12">
                  {{ formatDateString(like.dateAt, 'lll') }}<br>
                  #{{ like.documentId | truncate(30)}}
                </p>
              </td>
              <td>
                <span
                    class="badge"
                    :class="{
                  'bg-success': `${like.result}` === 'M',
                  'bg-info': `${like.result}` === 'L',
                  'bg-dark': `${like.result}` === 'D',
                }"
                >{{ $t(`likes.result_${like.result}`) }}</span
                >
              </td>
              <td>
                <div class="media cursor-pointer" @click="showUser(like.actionUserId)">
                  <div class="avatar-xs">
                    <img
                        :id="`like-liker-${like.documentId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-2">
                    <div>
                      <h5 class="font-size-12 mb-0">
                        <span
                            :class="{
                            'text-primary': like.likerSex === 1,
                            'text-danger': like.likerSex === 2,
                            'text-dark': like.likerSex === 0,
                          }"
                        >
                          {{ like.likerName || $t("deleted") }}
                        </span> {{ getAge(like.likerBirth) }}</h5>
                      <small class="text-muted">{{ like.actionUserId }}</small><br>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="media cursor-pointer" @click="showUser(like.userId)">
                  <div class="avatar-xs">
                    <img
                        :id="`like-user-${like.documentId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-2">
                    <div>
                      <h5 class="font-size-12 mb-0">
                        <span
                            :class="{
                            'text-primary': like.userSex === 1,
                            'text-danger': like.userSex === 2,
                            'text-dark': like.userSex === 0,
                          }"
                        >
                          {{ like.userName || $t("deleted") }}
                        </span> {{ getAge(like.userBirth) }}</h5>
                      <small class="text-muted">{{ like.userId }}</small><br>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <b>{{ getDistanceFromLatLng(like.userLat, like.userLng, like.likerLat, like.likerLng) }}</b> km<br>
                <b>{{ getAgeDiff(like.userBirth, like.likerBirth) }}</b> ans
              </td>
              <td>
                <div v-if="like.messageFlash.length > 0">
                  <small>{{ like.messageFlash | truncate(200)}}</small>
                </div>
                <div class="media cursor-pointer align-items-center" v-else-if="like.video.length > 0" @click="showMedia(like)">
                  <div class="avatar-md">
                    <img
                        :id="`like-video-${like.documentId}`"
                        :src="require('@/assets/images/default-video.png')"
                        class="d-flex rounded avatar-md" />
                  </div>
                  <div class="media-body ms-1">
                    <div>
                      <h5 class="font-size-12 mb-0">
                        <span class="badge rounded-pill bg-primary">
                          <b-icon icon="play-fill" aria-hidden="true" ></b-icon> {{ like.videoCount }}
                        </span>
                      </h5>
                    </div>
                  </div>
                </div>
                <p v-else> - </p>
              </td>
              <td>
                <span class="badge rounded-pill font-size-14"
                      :class="{
                    'bg-danger text-white': like.disabled === 1,
                    'bg-light text-dark': like.disabled === 0
                  }"
                >
                  <i class="bx " :class="{
                    'bx-trash': like.disabled === 1,
                    'bx-check': like.disabled === 0
                  }"></i>
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && likes.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No Likes/Matches were found for these filters or search. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="likes-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <CoolLightBox
        :items="media.media"
        :index="media.index"
        :effect="'fade'"
        @close="media.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>
.cursor-pointer {
  cursor: pointer;
}

.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}

.gender-img {
  max-width: 30px;
  margin-right: 10px;
}

</style>
